import { render, staticRenderFns } from "./XREFField.vue?vue&type=template&id=397cf17e&"
import script from "./XREFField.vue?vue&type=script&lang=js&"
export * from "./XREFField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports